const MASK = '••••';

const maskEmail = (email: string): string => {
  const atIndex = email.indexOf('@');
  if (atIndex < 1) return email;

  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  if (local.length < 2) return `${local}${MASK}${domain}`;

  return `${local.charAt(0)}${MASK}${local.charAt(local.length - 1)}${domain}`;
};

export default maskEmail;
